import React from "react";

import { Grid, Placeholder } from "semantic-ui-react";

import { CardLayout } from "../TemplateCard/components";

export function TemplateCardPlaceholder() {
  const placeholder = (
    <CardLayout>
      <Placeholder>
        <Placeholder.Header image>
          <Placeholder.Line length="long" />
          <Placeholder.Line length="short" />
        </Placeholder.Header>
        <Placeholder.Paragraph>
          <Placeholder.Line length="full" />
          <Placeholder.Line length="long" />
          <Placeholder.Line length="short" />
        </Placeholder.Paragraph>
        <Placeholder.Paragraph>
          <Placeholder.Header image>
            <Placeholder.Line length="long" />
            <Placeholder.Line length="short" />
          </Placeholder.Header>
        </Placeholder.Paragraph>
      </Placeholder>
    </CardLayout>
  );
  return (
    <Grid columns={3} style={{ width: "100%" }}>
      <Grid.Column>{placeholder}</Grid.Column>
      <Grid.Column>{placeholder}</Grid.Column>
      <Grid.Column>{placeholder}</Grid.Column>
    </Grid>
  );
}

export default TemplateCardPlaceholder;
